import axios from 'axios'
import { CommonFilterModel, CommonParams } from '@/api/resources/common/shared/models/common.models'
import {
    ConfigurationAutomaticAssignmentAlgorithmCreateRequest,
    ConfigurationAutomaticAssignmentAlgorithmPatchInBatchRequest,
    ConfigurationAutomaticAssignmentAlgorithmResponse
} from '@/modules/configurationModule/detail/automation/personnel/algorithms-definition/services/configuration-automatic-assignment-algorithm/configuration-automatic-assignment-algorithm.dto'
import { IResponseAgGrid } from '@/shared/models/ag-grid.model'
import { EntityIdentifiersRequest, EntityIdentifierWithErrorResponse } from '@/shared/models/http/http.model'

class ConfigurationAutomaticAssignmentAlgorithmService {
    async create(laboratoryId: number, request: ConfigurationAutomaticAssignmentAlgorithmCreateRequest): Promise<ConfigurationAutomaticAssignmentAlgorithmResponse> {
        const response = await axios.post<ConfigurationAutomaticAssignmentAlgorithmResponse>(`/configuration/laboratories/${laboratoryId}/automaticAssignmentAlgorithms`, request)
        return response.data
    }

    async paginator(filterModel: CommonFilterModel | undefined, params: CommonParams | undefined, laboratoryId: number): Promise<IResponseAgGrid<ConfigurationAutomaticAssignmentAlgorithmResponse>> {
        const response = await axios.put<IResponseAgGrid<ConfigurationAutomaticAssignmentAlgorithmResponse>>(`/configuration/laboratories/${laboratoryId}/automaticAssignmentAlgorithms`, { ...filterModel }, { params })
        return response.data
    }

    async get(automaticAssignmentAlgorithmId : number, laboratoryId: number): Promise<ConfigurationAutomaticAssignmentAlgorithmResponse> {
        const response = await axios.get<ConfigurationAutomaticAssignmentAlgorithmResponse>(`/configuration/laboratories/${laboratoryId}/automaticAssignmentAlgorithms/${automaticAssignmentAlgorithmId}`)
        return response.data
    }

    async delete(laboratoryId: number, request: EntityIdentifiersRequest): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await axios.delete<EntityIdentifierWithErrorResponse[]>(`/configuration/laboratories/${laboratoryId}/automaticAssignmentAlgorithms/batch`, { data: request })
        return response.data
    }

    async patch(laboratoryId: number, request: ConfigurationAutomaticAssignmentAlgorithmPatchInBatchRequest[]): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await axios.patch<EntityIdentifierWithErrorResponse[]>(`/configuration/laboratories/${laboratoryId}/automaticAssignmentAlgorithms/batch`, request)
        return response.data
    }
}

export const configurationAutomaticAssignmentAlgorithmService = new ConfigurationAutomaticAssignmentAlgorithmService()
